import { Button } from '../ui/button';
import { InteractDarkIcon, InteractLightIcon, InteractSystemModeIcon } from '@/client/assets';
import { useModeAnimation } from '@/client/hooks/use-mode-animate';
import { ThemeMode, useTheme } from '@/client/hooks/use-theme';
import { cn } from '@/client/utils';

const themes: {
  name: string;
  themeMode: ThemeMode;
  icon: React.FC<{ className?: string }>;
}[] = [
  {
    name: 'dark-mode',
    themeMode: 'dark',
    icon: InteractDarkIcon,
  },
  {
    name: 'light-mode',
    themeMode: 'light',
    icon: InteractLightIcon,
  },
  {
    name: 'system-mode',
    themeMode: 'auto',
    icon: InteractSystemModeIcon,
  },
];

export const SwitchTheme = () => {
  const { themeMode, setThemeMode } = useTheme();
  const { ref, startAnimate } = useModeAnimation<HTMLDivElement>();
  return (
    <div ref={ref} className="flex items-center gap-3 rounded-4 bg-foreground/4 p-1">
      {themes.map(item => (
        <Button
          key={item.themeMode}
          variant="ghost"
          size="icon"
          className={cn('size-4 p-0 text-foreground/30', themeMode == item.themeMode && 'text-foreground')}
          onClick={() => startAnimate(() => setThemeMode(item.themeMode))}
        >
          <item.icon className="!size-4 cursor-pointer fill-current" />
        </Button>
      ))}
    </div>
  );
};
